import { Route, Redirect } from "react-router-dom";

export const AdminProtectedRoute = ({ component: Component, ...rest }) => {
	const adminToken = localStorage.getItem("admin-token");

	const isLoggedIn = adminToken;

	const toast = "load toast";
	return (
		<Route
			{...rest}
			render={(props) => {
				if (isLoggedIn) {
					return <Component {...props} />;
				} else {
					localStorage.setItem("toast", toast);
					return (
						<Redirect
							to={{
								pathname: "/admin",
								state: {
									from: props.location,
								},
							}}
						/>
					);
				}
			}}
		/>
	);
};
